import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import axios from "axios";
import Sidebar from "../components/Sidebar";
import DashboardHeader from "../components/DashboardHeader";
import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

const BASE_URL = process.env.REACT_APP_API_BASE_URL;

const CourseList = () => {
  const dispatch = useDispatch();
  const [courses, setCourses] = useState([]);
  const [enrolledCourses, setEnrolledCourses] = useState([]);
  const [loading, setLoading] = useState(true);
  const [sidebarCollapsed, setSidebarCollapsed] = useState(false);
  const [error, setError] = useState(null);
  const [message, setMessage] = useState(null);
  const [profilePhoto, setProfilePhoto] = useState(null);

  const user = useSelector((state) => state.auth.user);
  const API_URL = `${BASE_URL}/courses/`;
  const token = localStorage.getItem("access");

  // Fetch profile photo separately
    useEffect(() => {
      const fetchUserProfile = async () => {
        try {
          const token = localStorage.getItem("access");
          const res = await axios.get(`${BASE_URL}/users/profile/`, {
            headers: { Authorization: `Bearer ${token}` },
          });
          const p = res.data.profile_photo;
          if (p) {
            setProfilePhoto(
              p.startsWith("http") ? p : `${BASE_URL}${p}`
            );
          } else {
            setProfilePhoto(null);
          }
        } catch (e) {
          setProfilePhoto(null);
        }
      };
      fetchUserProfile();
    }, []);

  useEffect(() => {
    const fetchData = async () => {
      try {
        // Fetch all courses
        const coursesResponse = await axios.get(API_URL, {
          headers: token ? { Authorization: `Bearer ${token}` } : {},
        });
        const courseList = Array.isArray(coursesResponse.data.results)
          ? coursesResponse.data.results
          : [];
        setCourses(courseList);

        // Fetch enrolled courses
        if (token) {
          const enrolledResponse = await axios.get(`${API_URL}`, {
            headers: { Authorization: `Bearer ${token}` },
          });
          setEnrolledCourses(
            enrolledResponse.data.map((enrollment) => enrollment.course.id)
          );
        }
      } catch (err) {
        //console.error(err);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, []);

  const handleRequestEnrollment = async (courseId) => {
    if (!token) {
      toast.error("Please log in to request enrollment.");
      setTimeout(() => setError(null), 3000);
      return;
    }

    try {
      const response = await axios.post(
        `${API_URL}${courseId}/request-enroll/`,
        {},
        { headers: { Authorization: `Bearer ${token}` } }
      );
      toast.success(response.data.message);
      setTimeout(() => setMessage(null), 3000);
      // Refresh enrolled courses after successful request
      const enrolledResponse = await axios.get(`${API_URL}`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      setEnrolledCourses(
        enrolledResponse.data.map((enrollment) => enrollment.course.id)
      );
    } catch (err) {
      toast.warning(err.response?.data?.error);
      setTimeout(() => setError(null), 3000);
    }
  };

  if (loading) {
    return (
      <div className="d-flex justify-content-center align-items-center vh-100">
        <div className="spinner-border text-primary" role="status">
          <span className="visually-hidden"></span>
        </div>
      </div>
    );
  }

  return (
    <div className="dashboard-container">
      <div className="d-flex">
        <Sidebar collapsed={sidebarCollapsed} toggleSidebar={() => setSidebarCollapsed((prev) => !prev)}/>
        <div className="main-content flex-grow-1">
          <DashboardHeader
            user={user}
            profilePhoto={profilePhoto}
            onToggleSidebar={() => setSidebarCollapsed(!sidebarCollapsed)}
          />
          <div className="dashboard-content p-4">
            <h2 className="dashboard-title mb-4">Available Courses</h2>
            {message && (
              <div
                className="alert alert-success alert-dismissible fade show"
                role="alert"
              >
                {message}
                <button
                  type="button"
                  className="btn-close"
                  data-bs-dismiss="alert"
                  aria-label="Close"
                ></button>
              </div>
            )}
            {error && (
              <div
                className="alert alert-danger alert-dismissible fade show"
                role="alert"
              >
                {error}
                <button
                  type="button"
                  className="btn-close"
                  data-bs-dismiss="alert"
                  aria-label="Close"
                ></button>
              </div>
            )}
            <div className="row row-cols-1 row-cols-md-2 row-cols-lg-3 g-4 mt-4">
              {courses.map((course) => (
                <div key={course.id} className="col">
                  <div className="card h-100 shadow-sm">
                    {course.image && (
                      <img
                        src={course.image}
                        className="card-img-top"
                        alt={course.title}
                        style={{ height: "200px", objectFit: "cover" }}
                      />
                    )}
                    <div className="card-body">
                      <h5 className="card-title">{course.title}</h5>
                      <p className="card-text text-muted">
                        {course.description}
                      </p>
                      <p className="card-text">
                        <small>Instructor: {course.instructor}</small>
                      </p>
                      <p className="card-text">
                        <small>Level: {course.level}</small>
                      </p>
                      <p className="card-text">
                        <small>
                          Rating:{" "}
                          {course.average_rating
                            ? course.average_rating.toFixed(1)
                            : "0.0"}{" "}
                          ★ ({course.review_count} reviews)
                        </small>
                      </p>
                    </div>
                    <div className="card-footer bg-transparent border-0">
                      {enrolledCourses.includes(course.id) ? (
                        <button className="btn btn-success w-100" disabled>
                          Enrolled
                        </button>
                      ) : (
                        <button
                          onClick={() => handleRequestEnrollment(course.id)}
                          className="btn btn-primary w-100"
                        >
                          Request Enrollment
                        </button>
                      )}
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CourseList;